<template>
	<slot :items="getAppUrls()" />
</template>

<script setup>
	const {getAppUrls} = useApiRoutes();
</script>
